import React from "react";

const User = props => (
  <svg viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M15.92 15.54c-.9-1.524-2.5-2.54-4.337-2.54h-2.5a4.946 4.946 0 00-4.336 2.54C6.115 17.062 8.107 18 10.333 18c2.188 0 4.18-.938 5.586-2.46zM.332 10.5a9.926 9.926 0 015-8.633c3.086-1.797 6.875-1.797 10 0 3.086 1.797 5 5.078 5 8.633 0 3.594-1.914 6.875-5 8.672-3.125 1.797-6.914 1.797-10 0-3.125-1.797-5-5.078-5-8.672zm10 .625c.977 0 1.914-.508 2.422-1.406.508-.86.508-1.914 0-2.813-.508-.86-1.445-1.406-2.422-1.406a2.87 2.87 0 00-2.46 1.406c-.508.899-.508 1.953 0 2.813.507.898 1.445 1.406 2.46 1.406z"
      fill="currentColor"
    />
  </svg>
);

export default User;
